import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../mensajes2";
import { validaSoloNumero } from "../../../util/varios";

import useTableScroll from "../../useTableSCrollAthos";
import CatalogoPersona from "../../../catalogos/catalogoPersona";
import CatalogoAlmacen from "../../../catalogos/catalogoAlmacen";
import { Dimmer } from "../../spinner";
import { Input, SearchInput, Select, Textarea } from "../../../ui/inputs/Input";
import { DangerButton, InfoButton, PrimaryButton, WarningButton } from "../../../ui/buttons/Button";

const headCells = [
  {
    id: "1",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "CODIGO",
    textAlign: "center",
  },
  {
    id: "2",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "DESCRIPCION",
    textAlign: "center",
  },
  {
    id: "3",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "RESPONSABLE",
    textAlign: "center",
  },
];

const TablaAlmacen = (props) => {
  const { TblContainer, TblHead } = useTableScroll(headCells);

  var op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idorganizacion = JSON.parse(localStorage.getItem("idorganizacion"));
  // let anio = JSON.parse(localStorage.getItem("anioactu"));
  // const fechaTope = moment.utc(JSON.parse(localStorage.getItem("fechasistema")))
  //   .format("YYYY-MM-DD")
  //   .replace(anio.toString(), (anio - 18).toString());
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
  const afiliado = JSON.parse(localStorage.getItem("riforganizacion"));
  // const accbtnregalmacen = JSON.parse(
  //   localStorage.getItem("accbtnregalmacenc")
  // );

  const btnCancela = useRef();
  const btnAcepta = useRef();
  // const txtVentas = useRef();
  const txtCodAlmacen = useRef();
  const txtDescripcion = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const txtFechaNac = useRef();

  const txtCedRes = useRef();
  const txtNomResp = useRef();
  const txtApeResp = useRef();
  const txtDireccion = useRef();
  const txtEmail = useRef();
  const txtTlf1 = useRef();
  const txtTlf2 = useRef();
  const [mostrar3, setMostrar3] = useState(false);
  const [titulo] = useState();
  const [msg] = useState();
  const [body, setBody] = useState(null);
  const [activate, setActivate] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(true);
  const [habilitado, setHabilitado] = useState(true);
  const [tituloHeader, setTituloHeader] = useState("Gestionar Almacenes.");
  const [operacion, setOperacion] = useState(0);

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [catalogoAlmacen, setCatalogoAlmacen] = useState(false);
  const [catalogoPersona, setCatalogoPersona] = useState(false);
  const [operacionPer, setOperacionPer] = useState(0);
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoper: true,
  });

  const [records, setRecords] = useState([]);
  const [Stock, setStock] = useState([]);

  const onChange = (e) => {
    if (
      e.target.name === "correoe" ||
      e.target.name === "apellidos" ||
      e.target.name === "direccion" ||
      e.target.name === "nombres" ||
      e.target.name === "descripcion"
    ) {
      /*  e.target.value = e.target.value.toUpperCase(); */
    } else if (
      e.target.name === "nacionalidad" &&
      txtCedRes.current.value !== ""
    ) {
      /*   if (e.target.value !== "") {
        datosRes();
      } else {
        txtCedRes.current.value = "";
        cmbSexo.current.value = "";
        txtFechaNac.current.value = "";
        txtNomResp.current.value = "";
        txtApeResp.current.value = "";
        txtDireccion.current.value = "";
        txtEmail.current.value = "";
        txtTlf1.current.value = "";
        txtTlf2.current.value = "";
        setHabilitadoNU(true);
      } */
    }
  };

  const seleccionarRegistro = (idalmacen) => {
    let campos = "*";
    let nomtab = "almacen";
    let nomid = "idalmacen";
    let id = idalmacen;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          txtDescripcion.current.value = "";
          if (response.data !== "") {
            setOperacionPer(0);
            txtCodAlmacen.current.value = idalmacen;
            txtDescripcion.current.value = response.data.descripcion.trim();
            if (!botones.modificar) {
              setBotones({ ...botones, catalogoper: false });
            }
            datosRes(response.data.responsable);
          } else {
            cmbNacionalidad.current.value = "";
            cmbSexo.current.value = "";
            txtFechaNac.current.value = "";
            txtNomResp.current.value = "";
            txtApeResp.current.value = "";
            txtDireccion.current.value = "";
            txtEmail.current.value = "";
            txtTlf1.current.value = "";
            txtTlf2.current.value = "";
            setHabilitadoNU(true);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un almacen con este codigo",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarAlmacen = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarRegistro(event.target.value);
      }
    }
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);

          if (response.data !== "") {
            setHabilitadoNU(true);
            setOperacionPer(0);
            txtCedRes.current.value = cedula;
            txtNomResp.current.value = response.data.nombres;
            txtApeResp.current.value = response.data.apellidos;
            txtDireccion.current.value = response.data.direccion;
            txtEmail.current.value = response.data.correoe;
            txtTlf1.current.value = response.data.tlf1;
            txtTlf2.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment.utc(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
          } else {
            setOperacionPer(1);
            setHabilitadoNU(false);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (cmbNacionalidad.current.value !== "") {
          datosRes(event.target.value);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "debe seleccionar la nacionalidad",
            icono: "informacion",
          });
          cmbNacionalidad.current.focus();
        }
      } else {
        cmbNacionalidad.current.value = "";
        cmbSexo.current.value = "";
        txtFechaNac.current.value = "";
        txtNomResp.current.value = "";
        txtApeResp.current.value = "";
        txtDireccion.current.value = "";
        txtEmail.current.value = "";
        txtTlf1.current.value = "";
        txtTlf2.current.value = "";
        setHabilitadoNU(true);
      }
    }
  };

  const onCatalogoAlmacen = (idalmacen) => {
    setCatalogoAlmacen(false);

    seleccionarRegistro(idalmacen);

    if (!botones.modificar) {
      setBotones({ ...botones, catalogoper: false });
    }
  };

  const onChangeValidar = () => {
    let sigue = true;
    if (!botones.incluir || !botones.modificar) {
      if (txtDescripcion.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar una descripción al Almacen",
          icono: "informacion",
        });
        txtDescripcion.current.focus();
        sigue = false;
      } else if (txtCedRes.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar la cedula el responsable",
          icono: "informacion",
        });
        txtCedRes.current.focus();
        sigue = false;
      } else if (operacionPer === 1) {
        if (cmbNacionalidad.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe seleccionar la nacionalidad del responsable",
            icono: "informacion",
          });
          cmbNacionalidad.current.focus();
          sigue = false;
        } else if (cmbSexo.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe seleccionar el Sexo del responsable",
            icono: "informacion",
          });
          cmbSexo.current.focus();
          sigue = false;
        } else if (txtFechaNac.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar fecha nacimiento del responsable",
            icono: "informacion",
          });
          txtFechaNac.current.focus();
          sigue = false;
        } else if (txtNomResp.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el nombre del responsable",
            icono: "informacion",
          });
          txtNomResp.current.focus();
          sigue = false;
        } else if (txtApeResp.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el apellido del responsable",
            icono: "informacion",
          });
          txtApeResp.current.focus();
          sigue = false;
        } else if (txtDireccion.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar la dirección del responsable",
            icono: "informacion",
          });
          txtDireccion.current.focus();
          sigue = false;
        } else if (txtEmail.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el correo del responsable",
            icono: "informacion",
          });
          txtEmail.current.focus();
          sigue = false;
        } else if (txtTlf1.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el Telefono del responsable",
            icono: "informacion",
          });
          txtTlf1.current.focus();
          sigue = false;
        } else if (txtTlf2.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el Celular del responsable",
            icono: "informacion",
          });
          txtTlf2.current.focus();
          sigue = false;
        }
      }
    }
    if (sigue) {
      var almacen = [];
      var repre = [];
      almacen.push({
        idalmacen:
          txtCodAlmacen.current.value === "" ? 0 : txtCodAlmacen.current.value,
        descripcion: txtDescripcion.current.value.trim(),
        idorganizacion: idorganizacion,
        responsable: txtCedRes.current.value,
      });
      repre.push({
        cedula: parseInt(txtCedRes.current.value),
        correoe: txtEmail.current.value.trim(),
        tlf1: txtTlf1.current.value.trim(),
        tlf2: txtTlf2.current.value.trim(),
        apellidos: txtApeResp.current.value.trim(),
        direccion: txtDireccion.current.value.trim(),
        fnacimiento: txtFechaNac.current.value.trim(),
        nacionalidad: cmbNacionalidad.current.value.trim(),
        nombres: txtNomResp.current.value.trim(),
        sexo: cmbSexo.current.value.trim(),
      });

      setBody({
        operacion: operacion,
        operacionper: operacionPer,
        almacen: almacen,
        repre: repre,
      });

      let msg = "";
      if (!botones.incluir) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (!botones.modificar) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (!botones.eliminar) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/comprasAlmacen/actalmacen`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (ope === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (ope === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (ope === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          setOperacion(0);
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_rif_key"'
          ) {
            mensaje = "Ya existe un Registro con este rif";
          } else if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_email_key"'
          ) {
            mensaje = "Ya existe un Registro con este correo";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const blanquear = () => {
    setTituloHeader("Gestionar Almacenes.");

    setActivate(false);
    setOperacion(0);
    setBody(null);
    setOperacionPer(0);
    setHabilitado(true);
    setHabilitadoNU(true);
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoper: true,
    });
    txtCodAlmacen.current.setAttribute("disabled", true);
    txtCodAlmacen.current.value = "";
    txtDescripcion.current.value = "";
    txtNomResp.current.value = "";
    txtApeResp.current.value = "";
    txtDireccion.current.value = "";
    txtEmail.current.value = "";
    txtTlf1.current.value = "";
    txtTlf2.current.value = "";
    txtFechaNac.current.value = "";
    cmbNacionalidad.current.value = "V";
    cmbSexo.current.value = "M";
  };

  const cancelar = () => {
    blanquear();
  };

  const cerrar = () => {
    blanquear();
    seleccionarRegistros();
    setVisibleBtn("visible");
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const seleccionarRegistros = () => {
    let endpoint = `${op.conexion}/api/comprasAlmacen/allalmacen`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            console.log(response.datas);
            setRecords(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const imprimirAlmacen = (tipo) => (e) => {
    e.preventDefault();
    if (tipo === 1) {
      window.open(
        `${op.reportes}/comprasyalmacen?afiliado=${afiliado}&reporte=ListaAlmacen`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else {
      window.open(
        `${op.reportes}/comprasyalmacen?afiliado=${afiliado}&reporte=ListProductoAlmacen`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    }
    /*  } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      }); 
    } */
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      setOperacion(op);

      /* if (
        accbtnregalmacen &&
        accbtnregalmacen.toString().substring(0, 1) === "1"
      ) { */
      setVisibleBtn("collapse");
      setTituloHeader("Incluir Almacenes.");
      setHabilitado(false);
      setBotones({
        incluir: false,
        consultar: true,
        modificar: true,
        eliminar: true,
        aceptar: false,
        cancelar: false,
        catalogo: true,
        catalogoper: false,
      });
      txtCodAlmacen.current.setAttribute("disabled", true);
      setTimeout(() => txtDescripcion.current.focus(), 200);
      /* } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      } */
    } else if (op === 2) {
      setOperacion(op);

      /* if (
        accbtnregalmacen &&
        accbtnregalmacen.toString().substring(1, 2) === "1"
      ) { */
      setVisibleBtn("collapse");
      setTituloHeader("Editar Almacenes.");
      txtCodAlmacen.current.removeAttribute("disabled");
      setHabilitado(false);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: false,
        eliminar: true,
        aceptar: false,
        cancelar: false,
        catalogo: false,
        catalogoper: true,
      });
      txtCodAlmacen.current.focus();
      /*  } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      } */
    } else if (op === 3) {
      setOperacion(op);

      /* if (
        accbtnregalmacen &&
        accbtnregalmacen.toString().substring(3, 4) === "1"
      ) { */
      setVisibleBtn("collapse");
      setTituloHeader("Eliminar Almacenes.");
      setHabilitado(true);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: true,
        eliminar: false,
        aceptar: false,
        cancelar: false,
        catalogo: false,
        catalogoper: true,
      });
      txtCodAlmacen.current.removeAttribute("disabled");
      txtCodAlmacen.current.focus();
      /*  } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      } */
    } else if (op === 4) {
      setOperacion(op);

      /* if (
        accbtnregalmacen &&
        accbtnregalmacen.toString().substring(2, 3) === "1"
      ) { */
      setVisibleBtn("collapse");
      setTituloHeader("Consultar Almacenes.");
      setHabilitado(true);
      setBotones({
        incluir: true,
        consultar: false,
        modificar: true,
        eliminar: true,
        aceptar: true,
        cancelar: false,
        catalogo: false,
        catalogoper: true,
      });
      txtCodAlmacen.current.removeAttribute("disabled");
      txtCodAlmacen.current.focus();
      /* } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      } */
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      setOperacion(0);
      setVisibleBtn("visible");
      cancelar();
    }
  };

  useEffect(() => {
    seleccionarRegistros();
  }, []);

  const handleInputChange = (event) => {
    /* if (event.which === 13) {
        var valido;
        if (event.target.id === 'inputNomUsuario') {
            txtApeResp.current.focus();
        } else if (event.target.id === 'inputApeUsuario') {
            txtDireccion.current.focus();
        } else if (event.target.id === 'inputDireUsuario') {
            txtEmail.current.focus();
        } else if (event.target.id === 'inputEmailUsuario') {
            valido = validaEmail(event.target.value);
            if (valido) {
                txtTlf1.current.focus();
            } else {
                if (event.target.value !== '') {
                    setTitulo('Información');
                    setMsg('Formato de Email invalido.');
                    setMostrar(true);
                    event.target.value = '';
                } else {
                    txtTlf1.current.focus();
                }
            }

        } else if (event.target.id === 'inputTlfUsuario') {
            valido = validaNumeroTelefono(event.target.value);
            if (valido) {
                txtTlf2.current.focus();
            } else {
                if (event.target.value !== '') {
                    setTitulo('Información');
                    setMsg('Formato de número telefonico invalido.');
                    setMostrar(true);
                    event.target.value = '';
                } else {
                    txtTlf2.current.focus();
                }
            }
        } else if (event.target.id === 'inputCelUsuario') {
            valido = validaNumeroTelefono(event.target.value);
            if (valido) {
                txtFechaNac.current.focus();
            } else {
                if (event.target.value !== '') {
                 
                    event.target.value = '';
                } else {
                    txtFechaNac.current.focus();
                }
            }
        } else if (event.target.id === 'inputFechaNac') {
            cmbNacionalidad.current.focus();
        }
    } else if (typeof (event.which) === 'undefined') {
      if (event.target.id === 'inputEmailUsuario') {
            valido = validaEmail(event.target.value);
            if (valido) {
                txtTlf1.current.focus();
            } else {
                if (event.target.value !== '') {
                   
                    event.target.value = '';
                } else {
                    txtTlf1.current.focus();
                }
            }

        } else if (event.target.id === 'inputTlfUsuario') {
            valido = validaNumeroTelefono(event.target.value);
            if (valido) {
                txtTlf2.current.focus();
            } else {
                if (event.target.value !== '') {
                 
                    event.target.value = '';
                } else {
                    txtTlf2.current.focus();
                }
            }
        } else if (event.target.id === 'inputCelUsuario') {
            valido = validaNumeroTelefono(event.target.value);
            if (valido) {
                txtFechaNac.current.focus();
            } else {
                if (event.target.value !== '') {
                    setTitulo('Información');
                    setMsg('Formato de número telefonico invalido.');
                    //setMostrar(true);
                    event.target.value = '';
                } else {
                    txtFechaNac.current.focus();
                }
            }
        } else {
            return false;
        }

    } else if (event.which === 46) {
        return false;
    } else if (event.which >= 48 && event.which <= 57) {
        return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
        return true;
    } else return false; */
    //alert(e.which);
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    /* if (operacion < 3) { */
    setMostrar3(true);
    /*   }  */
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer
  ) => {
    setMostrar3(false);
      txtCedRes.current.value = cedPer;
    txtNomResp.current.value = nomPer;
    txtApeResp.current.value = apePer;
    txtDireccion.current.value = direPer;
    txtEmail.current.value = correoPer;
    txtTlf1.current.value = tlf1Per;
    txtTlf2.current.value = tlf2Per;
    txtFechaNac.current.value = fnacPer;
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer; 
  };

 const cerrarM = () => {
    props.cerrar()
  }
  return (
    <div className="col-12 m-0 p-4 d-flex justify-content-between">
      <div className="col-6 m-0 p-0">
        <header className="col-12 m-0 px-4 py-2 mb-2 d-flex align-items-center justify-content-between rounded azulGradiant text-light">
          <h3 className="m-0 fw-bold">{tituloHeader}</h3>
          <a type='button' onClick={cerrarM} className="text-light fw-bold">
            Salir
            <i className="fas fa-times ms-2"></i>
          </a>
        </header>
        <div className="col-12 m-0 p-0 d-flex flex-wrap gap-2">
          <SearchInput
            label="Código Almacen:"
            type="text"
            autoComplete="off"
            ref={txtCodAlmacen}
            disabled
            onKeyUp={validarAlmacen}
            onBlur={validarAlmacen}
            name="idalmacen"
            disabledButton={botones.catalogo}
            onClickButton={() => setCatalogoAlmacen(true)}
          />
          <Textarea
            label="Descripción:"
            type="textarea"
            style={{ height: 70 }}
            autoComplete="off"
            disabled={habilitado}
            ref={txtDescripcion}
            onChange={onChange}
            name="descripcion"
          />

          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
            <legend className="float-none w-auto m-0">Datos Personales</legend>
            <div class="col-5 m-0 mb-2 p-0 input-group input-group-sm">
              <span class="input-group-text">Cedula:</span>
              <select
                name=""
                disabled={habilitado}
                ref={cmbNacionalidad}
                defaultValue={
                  props.datospersonales
                    ? props.datospersonales.nacionalidad
                    : ""
                }
                className="form-select col-3"
              >
                <option key="0" value="V">
                  V
                </option>
                <option key="1" value="E">
                  E
                </option>
              </select>
              <input
                type="text"
                disabled={habilitado}
                ref={txtCedRes}
                className="form-control form-control-sm"
                id="inputCedula"
                defaultValue={
                  props.datospersonales ? props.datospersonales.cedula : ""
                }
                onKeyUp={validarPersona}
                onBlur={validarPersona}
              />
              <button
                style={{ textAlign: "center", color: "white" }}
                disabled={botones.catalogoper}
                onClick={catalogoPer}
                className="btn btn-sm btn-info"
              >
                <i className="fas fa-search"> </i>
              </button>
            </div>
            <div class="col-3 m-0 mb-2 p-0 px-2">
              <Select label = "Sexo:"
                ref={cmbSexo}
                disabled={habilitadoNU}
                defaultValue={
                  props.datospersonales ? props.datospersonales.sexo : ""
                }
                options={[
                  { label: "M", value: "M" },
                  { label: "F", value: "F" },
                ]}
              />
            </div>
            <div class="col-4 m-0 mb-2 p-0 ">
              <Input label = 'Fecha de Nac.:'
                type="date"
                disabled={habilitadoNU}
                ref={txtFechaNac}
                id="inputFechaNac"
                max={fechasistema}
                defaultValue={
                  props.datospersonales
                    ? moment.utc(props.datospersonales.fnacimiento).format(
                        "YYYY-MM-DD"
                      )
                    : ""
                }
                onKeyUp={handleInputChange}
              />
            </div>
            <div class="col-6 m-0 mb-2 p-0">
              <Input label = 'Nombres:'
                disabled={habilitadoNU}
                ref={txtNomResp}
                id="inputNomUsuario"
                defaultValue={
                  props.datospersonales
                    ? props.datospersonales.nombres.trim()
                    : ""
                }
                onKeyUp={handleInputChange}
                onBlur={handleInputChange}
              />
            </div>
            <div class="col-6 m-0 mb-2 p-0 pl-2">
              <Input label = 'Apellidos:'
                disabled={habilitadoNU}
                ref={txtApeResp}
                id="inputApeUsuario"
                defaultValue={
                  props.datospersonales
                    ? props.datospersonales.apellidos.trim()
                    : ""
                }
                onKeyUp={handleInputChange}
                onBlur={handleInputChange}
              />
            </div>
            <div class="col-12 m-0 mb-2 p-0">
              <Textarea label = 'Dirección:'
                style={{ height: 70 }}
                disabled={habilitadoNU}
                ref={txtDireccion}
                id="inputDireUsuario"
                defaultValue={
                  props.datospersonales
                    ? props.datospersonales.direccion.trim()
                    : ""
                }
                onKeyUp={handleInputChange}
                onBlur={handleInputChange}
              />
            </div>
            <div class="col-4 m-0 p-0">
              <Input label = 'Correo:'
                disabled={habilitadoNU}
                ref={txtEmail}
                id="inputEmailUsuario"
                defaultValue={
                  props.datospersonales
                    ? props.datospersonales.correoe !== null
                      ? props.datospersonales.correoe.trim()
                      : ""
                    : ""
                }
                onKeyUp={handleInputChange}
                onBlur={handleInputChange}
              />
            </div>
            <div class="col-4 m-0 p-0 pl-2">
              <Input label = 'Telefono:'
                disabled={habilitadoNU}
                ref={txtTlf1}
                id="inputTlfUsuario"
                placeholder="0000-0000000"
                defaultValue={
                  props.datospersonales
                    ? props.datospersonales.tlf1 !== null
                      ? props.datospersonales.tlf1.trim()
                      : ""
                    : ""
                }
                onKeyUp={handleInputChange}
                onBlur={handleInputChange}
              />
            </div>
            <div class="col-4 m-0 p-0 pl-2">
              <Input label = 'Celular:'
                disabled={habilitadoNU}
                ref={txtTlf2}
                id="inputCelUsuario"
                placeholder="0000-0000000"
                defaultValue={
                  props.datospersonales
                    ? props.datospersonales.tlf2 !== null
                      ? props.datospersonales.tlf2.trim()
                      : ""
                    : ""
                }
                onKeyUp={handleInputChange}
                onBlur={handleInputChange}
              />
            </div>
          </fieldset>

          <div className="d-none">
            <PrimaryButton icon = 'fa-print'
              onClick={imprimirAlmacen(1)}
            >
              Almacenes
            </PrimaryButton>
            <PrimaryButton icon = 'fa-print'
              onClick={imprimirAlmacen(2)}
            >
              Productos
            </PrimaryButton>
          </div>
        </div>
        {visibleBtn === "visible" &&
          <div className="col-12 m-0 mt-2 p-0 d-flex gap-2 justify-content-end">
            <PrimaryButton icon = 'fa-plus'
              disabled={botones.incluir}
              onClick={onBotones(1)}
            >
              Incluir
            </PrimaryButton>
            <InfoButton icon = 'fa-eye'
              disabled={botones.consultar}
              onClick={onBotones(4)}
            >
              Consultar
            </InfoButton>
            <WarningButton icon = 'fa-edit'
              disabled={botones.modificar}
              onClick={onBotones(2)}
            >
              Modificar
            </WarningButton>
            <DangerButton
              disabled={botones.eliminar}
              onClick={onBotones(3)}
            >
              Eliminar
            </DangerButton>
          </div>
        }

        {visibleBtn !== "visible" &&
          <div className="col-12 m-0 mt-2 p-0 d-flex gap-2 justify-content-end">
            <button
              disabled={botones.aceptar}
              onClick={onBotones(5)}
              ref={btnAcepta}
              className="btn btn-sm rounded-pill btn-success"
            >
              <i className="fas fa-check-circle"> Aceptar</i>
            </button>
            <button
              disabled={botones.cancelar}
              onClick={onBotones(6)}
              ref={btnCancela}
              className="btn btn-danger btn-sm rounded-pill"
            >
              <i className="fas fa-window-close"> Cancelar</i>
            </button>
          </div>
        }
      </div>
      <div className="col-5 m-0 p-2 border-azul rounded d-flex flex-wrap">
        <div className="col-12 m-0 mb-2 p-0 d-flex align-items-center justify-content-between">
          <h3 className="m-0 fw-bold">
            Listado de Almacenes
          </h3>
          <div className="d-flex gap-2">
            <button className="btn btn-sm btn-primary rounded-pill"
              type="button"
              onClick={imprimirAlmacen(1)}
            >
              <i className="fas fa-print"> Almacenes</i>
            </button>
            <button className="btn btn-sm btn-primary rounded-pill"
              type="button"
              onClick={imprimirAlmacen(2)}
            >
              <i className="fas fa-print"> Productos</i>
            </button>
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer
            container={{
              height: 220,
              width: "100%",
              overflow: "auto",
              padding: "2px",
              backgroundColor: "white",
              fontSizeAdjust: "0.6",
            }}
          >
            <TblHead />
            <tbody className="overflow-hidden table-bordered">
              {records &&
                records.map((item, index) => (
                  <tr key={index} style={{ padding: "0" }}>
                    <td
                      className="align-baseBar bg-light"
                      style={{ textAlign: "center", width: "20px" }}
                    >
                      {item.idalmacen}
                    </td>
                    <td
                      className="align-baseline bg-light"
                      style={{ textAlign: "center", width: "80px" }}
                    >
                      {item.descripcion}
                    </td>
                    <td
                      className="align-baseline bg-light"
                      style={{ textAlign: "center", width: "80px" }}
                    >
                      {item.nombres + " " + item.apellidos}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
        </div>
        <div className="col-12 m-0 mt-2 p-0 d-flex align-item-center gap-2">
          <div className="col m-0 p-2 bg-success rounded">
            <span>Total Ubicaciones:</span>
            <h1 className="col text-right">{records.length} </h1>
          </div>
          <div className="col m-0 p-2 bg-info rounded">
            <span>Productos en Stock:</span>
            <h1 className="col text-right">{Stock.length} </h1>
          </div>
          <div className="col m-0 p-2 bg-warning rounded">
            <span>Total:</span>
            <h1 className="col text-right">0</h1>
          </div>
        </div>
      </div>
      <CatalogoAlmacen
        show={catalogoAlmacen}
        onHideCancelar={() => setCatalogoAlmacen(false)}
        onHideAceptaCatalogo={onCatalogoAlmacen}
      />
      <CatalogoPersona
        titulo={titulo}
        mensaje={msg}
        show={mostrar3}
        onHideCancelaCatPer={handleCloseCatalogoPer}
        onHideAceptaCatPer={handleAceptaCatalogoPer}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrar()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
};
export default TablaAlmacen;
